// import React from 'react'

import { Link } from 'react-router-dom';
import PageStructure from '../../layout/PageStructure';

const Settings = () => {
  return (
    <PageStructure>
      <main className="excluded-page">
        <h2>Settings</h2>
        Settings page not included in design. Go to your{' '}
        <Link
          to={'/dashboard'}
          style={{
            color: 'var(--button-orange-background-color)',
            fontSize: '3rem',
          }}
        >
          Dashboard
        </Link>
      </main>
      ;
    </PageStructure>
  );
};

export default Settings;
